import Vue from 'vue'
import axios from 'axios'

const state = {
  tablas: []
}

const mutations = {
  AGREGAR_TABLA(state, tabla) {
    Vue.set(state.tablas, tabla.id, tabla)
  },
  BORRAR_TABLA: (state, params) => {
    // state.grupos.splice(params.id, 1)
    Vue.set(state.tablas, params.id, undefined)
  },
  LIMPIAR_TABLAS(state) {
    state.tablas = []
  }
}

const actions = {
  obtenerTablas(context, base) {
    context.commit('MOSTRAR_SNACK', { texto: 'Obteniendo tablas' }, { root: true })
    context.commit('LIMPIAR_TABLAS')
    axios.post('https://api.vlivemedia.com/v1/Tablas/Obtener', {base: base})
      .then(function (response) {
        if (response.data.data && response.data.data.length) {
          console.log(response.data)
          response.data.data.forEach(function (tabla) {
            context.commit('AGREGAR_TABLA', tabla)
          })
          context.commit('OCULTAR_SNACK', null, { root: true })
        } else {
          console.log("Ninguna tabla")
          console.log(response)
        }
      });
  },
  agregarTabla(context, tabla) {
    context.commit('MOSTRAR_SNACK', {texto: 'Agregando tabla "' + tabla.nombre + '"'}, { root: true })
    axios.post('https://api.vlivemedia.com/v1/Tablas/Crear', {nombre: tabla.nombre, base: tabla.base})
      .then(function (response) {
        if (response.data.status === 200) {
          context.commit('AGREGAR_TABLA', response.data.data)
          context.commit('OCULTAR_SNACK', null, { root: true })
        } else {
          console.log("Error")
          console.log(response)
        }
      })
  },
  borrarTabla(context, tabla) {
    context.commit('MOSTRAR_SNACK', {texto: 'Borrando tabla "' + tabla.nombre + '"'}, { root: true })
    axios.post('https://api.vlivemedia.com/v1/Tablas/Borrar', {id: tabla.id, nombre: tabla.nombre, base: tabla.base})
      .then(function (response) {
        if (response.data.status === 200) {
          context.commit('BORRAR_TABLA', {
            id: tabla.id
          })
          context.commit('OCULTAR_SNACK', null, { root: true })
        } else {
          context.commit('MOSTRAR_SNACK', {texto: response.data.mensaje}, { root: true })
        }
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}